import {
  LayoutDashboard,
  Users,
  UserCog,
  UserCircle,
  Building2,
  ShieldCheck,
  Megaphone,
  FileText,
  FileArchive,
  FileSpreadsheet,
  FileBox,
  IdCard,
  Layers3,
  CalendarDays,
  CalendarClock,
  Settings,
  Lock,
  Briefcase,
  UserCheck,
  UserPlus,
  ClipboardList,
  Wallet,
  DollarSign,
  Receipt,
  HandCoins,
  PlaneTakeoff,
  UserX,
  Inbox,
  FileSignature,
  GraduationCap,
  Calculator,
  Clock,
  Clipboard,
  Package,
  Boxes,
  Monitor,
  HardDrive,
  Server,
  BarChart3,
  LifeBuoy,
  Database,
  ArrowLeftRight,
  CreditCard,
} from "lucide-react";
import { buildDynamicNav } from "../components/common/CommonFunctions";

export const useNavigation = () => {

  const userPermissionList = JSON.parse(sessionStorage.getItem("loginUserPermission")) || [];
  const is_superAdmin = JSON.parse(sessionStorage.getItem("is_super_admin"))
  const is_Admin = JSON.parse(sessionStorage.getItem("is_admin"))

  const defaults = {
    employee: [
      "employees",
      "leave request",
      "reimbursement request",
      "advance salary request",
      "subordinates",
      "resignation",
    ],

    attendance: [
      "day attendance",
      "attendance log"
    ],

    // ignored: because we attached the salary calculator in salary remplate creation screen
    // payroll: [ 
    //   "salary calculator" 
    // ],

    ...(is_superAdmin || is_Admin ? {
      "data migration": ["employee migration"],
      fullMenus: ["reports", "settings", "help", "plans"],
    } : {
      fullMenus: ["settings", "help"],
    })
  };
  const navItems = [
    // Dashboard changes based on role
    { label: "Home", href: "/home", icon: LayoutDashboard },

    // Admin Panel (only for admin roles)
    {
      label: "Administrator",
      href: "/admin",
      icon: UserCog,
      subItems: [
        { label: "Organization", href: "/admin/companyprofile", icon: Building2 },
        { label: "User Group", href: "/admin/usergroup", icon: Users },
        { label: "User Permission", href: "/admin/userpermission", icon: ShieldCheck },
        { label: "Notice Board", href: "/admin/noticeboard", icon: Megaphone },
        { label: "Password Policy", href: "/admin/passwordpolicy", icon: Lock },
        { label: "Organization Documents", href: "/admin/organizationdocuments", icon: FileArchive },
      ],
    },

    // Master (Admin/Superadmin only)
    {
      label: "Master",
      href: "/master",
      icon: Layers3,
      subItems: [
        { label: "Employee Type", href: "/master/employeetype", icon: IdCard },
        { label: "Department", href: "/master/department", icon: Building2 },
        { label: "Designation", href: "/master/designation", icon: Briefcase },
        { label: "Leave Type", href: "/master/leavetype", icon: CalendarClock },
        { label: "Employee Group", href: "/master/employeegroup", icon: Users },
        { label: "Reimbursements Type", href: "/master/reimbursementstype", icon: Receipt },
        { label: "Asset Type", href: "/master/assettype", icon: Package },
        { label: "Asset Category", href: "/master/assetcategory", icon: Boxes },
        { label: "Asset Sub Category", href: "/master/assetsubategory", icon: FileBox },
        { label: "Letter Type", href: "/master/lettertype", icon: FileText },
        { label: "Letter Template", href: "/master/lettertemplate", icon: FileSignature },
      ],
    },

    // Configuration (Admin/Superadmin only)
    {
      label: "Configuration",
      href: "/configuration",
      icon: Settings,
      subItems: [
        { label: "Shift Configuration", href: "/configuration/shiftconfiguration", icon: CalendarClock },
        { label: "Holiday", href: "/configuration/holiday", icon: CalendarDays },
        { label: "Week off", href: "/configuration/weekoff", icon: Clipboard },
        { label: "Payroll Period", href: "/configuration/payrollperiod", icon: CalendarDays },
        { label: "Subordinate Setup", href: "/configuration/subordinate", icon: UserCheck },
        { label: "Salary Component", href: "/configuration/salarycomponent", icon: Wallet },
        { label: "Salary Template", href: "/configuration/salarytemplate", icon: FileSpreadsheet },
      ],
    },

    // Employee Section
    {
      label: "Employee",
      href: "/employee",
      icon: UserCircle,
      subItems: [
        { label: "Employees", href: "/employee", icon: Users }, // Default
        { label: "Leave Request", href: "/employee/leaverequest", icon: PlaneTakeoff }, // Default
        { label: "Reimbursement Request", href: "/employee/reimbursementrequest", icon: Receipt }, // Default
        { label: "Advance Salary Request", href: "/employee/advancerequest", icon: HandCoins }, // Default
        { label: "Subordinates", href: "/employee/subordinate", icon: UserCheck }, // Default
        // { label: "Resignation", href: "/employee/resignationrequest", icon: UserX }, // Default
        { label: "Approval Inbox", href: "/employee/approvalinbox", icon: Inbox },
        // { label: "TDS Declaration Form", href: "/employee/tdsdeclaration", icon: FileText },
        { label: "Employee Onboarding", href: "/employee/onboarding", icon: UserPlus },
        { label: "Intern Onboarding", href: "/employee/internonboarding", icon: GraduationCap },
      ].filter(Boolean), // clean nulls if condition fails
    },

    // Payroll (Admin/Superadmin only)
    {
      label: "Payroll",
      href: "/payroll",
      icon: DollarSign,
      subItems: [
        // { label: "Run Payroll", href: "/payroll/runpayroll", icon: ClipboardList },
        { label: "Payroll", href: "/payroll/payrollprocess", icon: FileText },
        { label: "Payslips", href: "/payroll/payslips", icon: FileSpreadsheet },
        // { label: "Salary Calculator", href: "/payroll/salarycalcualtor", icon: Calculator }, ignored: because we attached the salary calculator in salary remplate creation screen 
      ],
    },

    // Attendance (All users, but different)
    {
      label: "Attendance",
      href: "/attendance",
      icon: Clock,
      subItems: [
        { label: "Day Attendance", href: "/attendance/dayattendance", icon: CalendarDays },
        { label: "Attendance Log", href: "/attendance/attendancelog", icon: ClipboardList },
      ],
    },

    // Asset Management (Admin/Superadmin only)
    {
      label: "Asset Management",
      href: "/assetmanagement",
      icon: Monitor,
      subItems: [
        { label: "Asset Registry", href: "/assetmanagement/assetregistry", icon: HardDrive },
        { label: "Asset Employee Audit", href: "/assetmanagement/assetemployeeaudit", icon: Server },
      ],
    },

    // Roster (everyone)
    { label: "Roster", href: "/roster", icon: CalendarClock },

    // {
    //   label: "Data Migration",
    //   href: "/datamigration",
    //   icon: Database,
    //   subItems: [
    //     { label: "Employee Migration", href: "/datamigration/employeemigration", icon: ArrowLeftRight },
    //   ],
    // },

    // Reports (all, but richer for admin)
    {
      label: "Reports",
      href: "/reports",
      icon: BarChart3,
      isSecondary: true,
    },

    // Settings (admin only)
    {
      label: "Settings",
      href: "/settings",
      icon: Settings,
      isSecondary: true,
    },

    // { label: "Plans", href: "/plans", icon: CreditCard, isSecondary: true },

    // Help (everyone)
    // { label: "Help", href: "/help", icon: LifeBuoy, isSecondary: true },


  ].filter(Boolean); // remove false entries

  const dynamicNav = buildDynamicNav(navItems, userPermissionList, defaults);

  return { navItems, dynamicNav };
};
